export default "__VITE_ASSET__B0qS7vD3__ 430w";